/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Wizard_Refine_ErrorInputs */



/**
* | output |
* | --- |
* | "Uno could not refine the text. Your own words are unchanged." |
*
* @param {Agent_Wizard_Refine_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_refine_error = /** @type {((inputs?: Agent_Wizard_Refine_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_Refine_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Uno konnte den Text nicht verfeinern. Ihre eigenen Worte bleiben unverändert.")
	return /** @type {LocalizedString} */ ("Uno could not refine the text. Your own words are unchanged.")
});